import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import LeftArrowAccordian from "../../../icons/LeftArrowAccordian";
import CrossIcon from "../../../icons/CrossIcon";
import { JBFormWrapper } from "./JointBidder/JBFormWrapper";
import IndividualBidderForm from "./Individual/IndividualBidderFormV2";
import NonIndividualBidderForm from "./NonIndividual/NonIndividualBidderFormV2";
import { Button } from "../../../shadcn/components/ui/button";
import { getBidderByUuid, NON_INDIVIDUAL_BIDDER_TYPES } from "services";
import { AddBidderFormType } from "./bidderFormServices/getDetails";

interface props {
  mode?: string;
}

interface JointBidderItem {
  email: string;
  bidder_uuid?: string;
  access_type?: string;
  name?: string;
}
export const AddBidderV2 = ({ mode }: props) => {
  const router = useRouter();
  const { bidder_type, id } = router.query as {
    bidder_type?: AddBidderFormType;
    id?: string;
  };
  const non_individual_types: string[] = NON_INDIVIDUAL_BIDDER_TYPES;
  const [showJBListModal, setShowJBListModal] = useState(mode !== "edit");
  const [jbCount, setJbCount] = useState(0);

  const fetchJBCount = async () => {
    try {
      const data: any = await getBidderByUuid(id as string);
      const relations: any[] = data?.bidder_relations || [];
      const extracted: JointBidderItem[] = relations
        .map((rel: any) => ({
          email: rel?.meta?.email,
          bidder_uuid: rel?.bidder_uuid,
          access_type: rel?.type,
          name: rel?.meta?.name,
        }))
        .filter(
          (rel: JointBidderItem) =>
            typeof rel.email === "string" && rel.email.trim().length > 0,
        );

      // Ensure Primary (if any) is first
      const isPrimary = (t?: string) =>
        (t || "").toLowerCase() === "primary" ||
        (t || "").toLowerCase() === "owner";
      const sorted = [...extracted].sort(
        (a, b) =>
          (isPrimary(b.access_type) ? 1 : 0) -
          (isPrimary(a.access_type) ? 1 : 0),
      );

      setJbCount(sorted.length);

      // setItems(sorted);
    } catch (err: any) {
      console.log("error", err);
    }
  };

  function capitalize(str: string) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  const handleHeadingText = (
    accessMode: string | undefined,
    bidderType: string | undefined,
  ) => {
    const normalizedMode = accessMode || "create"; // default
    const type = bidderType || "individual"; // default

    const isJoint = type === "joint";
    const isNI = non_individual_types.includes(type);

    if (normalizedMode === "view") {
      if (isJoint) {
        return `Bidder Details - Joint (${jbCount})`;
      }
      if (isNI) return `Bidder Details - ${capitalize(type)}`;
      return "Bidder Details - Individual";
    }

    if (normalizedMode === "edit") {
      if (isJoint) return "Update Primary Joint Bidder Details";
      if (isNI) return `Update Bidder Details - ${capitalize(type)}`;
      return "Update Bidder Details - Individual";
    }

    // create (default)
    if (isJoint) return "Add Joint Bidder Details";
    if (isNI) return `Add Bidder Details - ${capitalize(type)}`;
    return "Add Bidder Details - Individual";
  };

  useEffect(() => {
    if (!id || bidder_type !== "joint") return;
    fetchJBCount();
  }, [id]);

  return (
    <div className="px-4 py-5 lg:py-6 lg:px-8">
      <div className="flex  items-center ">
        <div className="flex items-center w-full">
          <button
            className="hidden lg:flex"
            onClick={() => {
              router.back();
            }}
          >
            <LeftArrowAccordian className="h-6 w-6" />
          </button>
          <p className="font-openSans font-normal text-mobile-h3 lg:text-web-subheading leading-8 lg:leading-6 lg:ml-5 text-bankerColor">
            {handleHeadingText(mode, bidder_type)}
          </p>
          <div className="ml-auto flex justify-center items-center space-x-2 ">
            <Button
              onClick={() => setShowJBListModal(true)}
              className={`ml-auto ${
                bidder_type === "joint" && mode !== "create" ? "" : "hidden"
              }`}
            >
              Jt. Bidder Details
            </Button>
            <div
              onClick={() => {
                router.back();
              }}
              className="lg:hidden"
            >
              <CrossIcon />
            </div>
          </div>
        </div>
      </div>
      {bidder_type === "individual" && <IndividualBidderForm mode={mode} />}
      {bidder_type === "joint" && (
        <JBFormWrapper
          mode={mode}
          showJBListModal={showJBListModal}
          setShowJBListModal={setShowJBListModal}
        />
      )}
      {non_individual_types.includes(bidder_type ?? "") && (
        <NonIndividualBidderForm mode={mode} user_type={bidder_type} />
      )}
    </div>
  );
};

export default AddBidderV2;
